export default __webpack_public_path__ + "static/media/Marlins.4343c521.png";